<footer class="bottom">
    <!-- <div class="rodape app-texto-cor app-button">
        <span class="hidden-xs">Todos os direitos reservados - Central de atendimento</span> <i
            class="fa fa-phone"></i> (11) 4133-5160 <br>
        <span class="link-read-polices-terms" (click)="readPoliciesAndTerms()"><em class="hidden-xs">Clique aqui e
                confira nossas </em>
            <em>Políticas de Privacidade e Termos de Uso.</em></span>
    </div> -->
    <div class="rodape-v2">
        <div class="logo-copy">
            <img *ngIf="!isCustomized" src="../../assets/img/PicPontos_logo.svg" alt="Logotipo">
            <div class="visible-xs">
                <ul class="footer-nav-list">
                    <li (click)="mainService.loginService.changeRoute('/cartao')">Cadastro</li>
                    <li (click)="mainService.loginService.changeRoute('/perguntas-frequentes')">Dúvidas</li>
                    <li (click)="mainService.loginService.changeRoute('/sac')">SAC</li>
                    <li (click)="mainService.loginService.doLogout()">Sair</li>
                </ul>
            </div>
            <span>Todos os direitos reservados</span>
            <span class="link-read-polices-terms"
                (click)="mainService.loginService.changeRoute('/politicas-e-termos')"><em>Políticas de Privacidade e
                    Termos de Uso.</em></span>
        </div>
        <div class="contato hidden-xs">
            <span>Central de <br>Relacionamento <br>com o premiado</span>
            <div class="contato-telefone">
                <img src="../../assets/img/telefone.png" alt="Telefone">
                <a href="tel:+551139953011"><span>(11) 3995-3011</span></a>
            </div>
        </div>
    </div>
</footer>

<!--<div class="modal"
     id="modalAvisosCI"
     tabindex="-1"
     role="dialog"
     data-backdrop="static">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-body">
                <div class="modal-header">
                    <h4 class="modal-title">{{mainService.loginService.ciService.avisosCI[0].assunto}}</h4>
                </div>

                <div class="modal-body" style="min-height: 150px" >
                    <i class="fa fa-exclamation-circle fa-5x fa-pull-left fa-border" aria-hidden="true"></i>
                   <p style="white-space: pre-line">{{mainService.loginService.ciService.avisosCI[0].mensagem}}</p>
                </div>

                <div class="modal-footer">
                    <button type="button" 
                            ng-click="mainService.loginService.ciService.excluirAvisoCI()"
                            class="btn btn-danger app-btn">Excluir</button>
                    <button type="button" 
                            ng-click="mainService.loginService.ciService.fecharAvisoCI()"
                            class="btn app-btn app-btn-best">Fechar</button>
                </div>
            </div>
        </div>
    </div>
</div>-->


// WEBPACK FOOTER //
// ./src/app/app-footer/app-footer.component.html